import { lazy, Suspense } from 'react';
import { App } from './App.tsx';
import { isAdminHost } from '@/lib/adminHost';
import { isModulesHost } from '@/lib/modulesHost';

// Lazy so the admin portal never lands in the user app's initial bundle.
const AdminApp = lazy(() => import('./admin/AdminApp.tsx').then(m => ({ default: m.AdminApp })));
const ModulesHostPage = lazy(() => import('./pages/ModulesHost/ModulesHostPage.tsx').then(m => ({ default: m.ModulesHostPage })));

/**
 * Host branch for the single build: `admin.gozig.com` (and the per-environment equivalents) gets
 * the admin portal, the cmi5 module host gets a bare shell, everything else gets the user app. The
 * API enforces the same split itself, so this is only about which bundle renders.
 */
export const RootApp = () => {
    if (isModulesHost()) {
        return (
            <Suspense fallback={null}>
                <ModulesHostPage />
            </Suspense>
        );
    }

    if (!isAdminHost()) {
        return <App />;
    }

    return (
        <Suspense fallback={null}>
            <AdminApp />
        </Suspense>
    );
};
